import React from "react";
import { DEFAULT_PREVIEW_TEXT } from "us.collection.input-output/constants";
import { FileImageOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
type PreviewPanelProps = {
  previewUrl: string | null;
  previewText: string;
};
/**
@description
PreviewPanel Component
Displays a preview of the currently selected document or a placeholder text/icon when none
is available. Renders PDFs in an embedded object/iframe and falls back to a placeholder.
Features:
- Embedded PDF preview using object/iframe
- Placeholder and default preview text handling
@link https://unicorn-solutions.atlassian.net/browse/UPD-20
@author Keshan Nimnaka <keshana@unicorn-solutions.com>
@since 29/06/2026
*/
const PreviewPanel: React.FC<PreviewPanelProps> = ({
  previewUrl,
  previewText,
}) => {
  const showNoPreviewIcon = !previewUrl && previewText === DEFAULT_PREVIEW_TEXT;
  const { t } = useTranslation();
  return (
    <div className="home-preview-container">
      {previewUrl ? (
        <object
          aria-label={t("US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER.PREVIEW")}
          data={`${previewUrl}#toolbar=0`}
          type="application/pdf"
          className="home-preview-embed"
        >
          <iframe
            title={t(
              "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER.PREVIEW_FALLBACK",
            )}
            src={`${previewUrl}#toolbar=0&view=FitH`}
            className="home-preview-embed"
          />
        </object>
      ) : (
        <div className="home-preview-placeholder">
          <div className="no-preview-content">
            {showNoPreviewIcon && (
              <FileImageOutlined
                style={{ fontSize: 48 }}
                role="img"
                aria-hidden="true"
              />
            )}
            <div className="home-preview-placeholder-text">{previewText}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewPanel;
